import Page from 'src/components/layouts/Page';
import css from './StoreInfo.module.scss';
import GoogleMapReact from 'google-map-react';
import { useEffect, useState } from 'react';
import Switch from 'src/components/atoms/Switch';
import InputWrap from 'src/components/molecules/InputWrap';
import ItemImages from 'src/components/organisms/ItemImages';
import Button from 'src/components/atoms/Button';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
// import Dropdown from "src/components/molecules/Dropdown";
import Select from 'react-select';
import Dropzone from 'react-dropzone';
import S3 from 'react-aws-s3';
// import moment from "moment";
import HoursSelector from 'src/components/organisms/HoursSelector';

// FIXME: Todo
// var customParseFormat = require('dayjs/plugin/customParseFormat')

import { TimeInput } from '@mantine/dates';
import MapMarker from 'src/components/atoms/MapMarker';
import NumberFormat from 'react-number-format';
import { clearState, getBusinessInfo, updateBusinessInfo } from 'src/slices/info';
import { checkPermissions, handleStatus, handleToast } from 'src/slices/utils';
import EmptyPage from 'src/components/molecules/EmptyPage';

// Custom parse format used to parse store hours
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
// import Pill from "src/components/atoms/Pill";
dayjs.extend(customParseFormat);

export default function StoreInfo() {
  const dispatch = useDispatch();
  const { businessInfo, status } = useSelector((state) => state.info);
  const { permissions } = useSelector((state) => state.auth);

  const [storeInfo, setStoreInfo] = useState({
    businessName: '',
    businessDescription: '',

    phone: '',
    notifPhone: '',
    neighborhood: '',
    // FIXME: Should not be an array
    businessCategory: '',

    hours: [],

    allowDineIn: false,
    inHouseDelivery: false,
    isFreeDelivery: false,
    minOrderAmt: 0,
    maxDeliveryRange: 0,
    deliveryChrgBase: 0,
    deliveryPerAddlMile: 0,

    businessLogo: '',
    businessPhotos: [],

    liveMessage: '',
    address: '',

    coordinates: [],
  });

  const categories = [
    {
      value: 'restaurant',
      label: 'Restaurant',
    },
    {
      value: 'grocery',
      label: 'Grocery',
    },
    {
      value: 'cafe',
      label: 'Cafe',
    },
    {
      value: 'bakery',
      label: 'Bakery',
    },
  ];

  // FIXME !
  const config = {
    bucketName: 'carty-app',
    region: 'us-east-1',
    accessKeyId: 'AKIAQHLGGFVPLOMRLX5O',
    secretAccessKey: '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',
    s3Url: 'https://carty-app.s3.amazonaws.com' /* optional */,
  };

  const createMapOptions = {
    panControl: false,
    mapTypeControl: false,
    scrollwheel: false,
    zoomControl: false,
    fullscreenControl: false,
    draggable: false,
    scaleControl: true,
    keyboardShortcuts: false,
    styles: [
      {
        featureType: 'poi', // turn of places markes
        stylers: [{ visibility: 'off' }],
      },
      {
        stylers: [{ saturation: 0 }],
      },
    ],
  };
  const map = {
    zoom: 17,
  };
  const updateStoreInfo = (field, value, callback) => {
    setStoreInfo({ ...storeInfo, [field]: value });
    callback && callback();
  };
  const updateTime = (time, index, type) => {
    setStoreInfo({
      ...storeInfo,
      hours: storeInfo.hours.map((day, i) =>
        index === i
          ? {
              ...day,
              [type]: dayjs(time, 'HH:mm').format('HH:mm').toString().toUpperCase(),
            }
          : day,
      ),
    });
  };

  const updateIsClosed = (index) => {
    setStoreInfo({
      ...storeInfo,
      hours: storeInfo.hours.map((day, i) =>
        index === i
          ? {
              ...day,
              isClosed: !day.isClosed,
            }
          : day,
      ),
    });
  };

  // New code, by Shahriar
  const addSubDay = (index, day) => {
    let newHours = [...storeInfo.hours];
    newHours.splice(index + 1, 0, {
      day: day,
      openTime: '00:00 AM',
      closeTime: '00:00 AM',
      isClosed: false,
      isSub: true,
    });
    setStoreInfo({
      ...storeInfo,
      hours: newHours,
    });
  };

  const removeSubDay = (index) => {
    let newHours = [...storeInfo.hours];
    newHours.splice(index, 1);
    setStoreInfo({
      ...storeInfo,
      hours: newHours,
    });
  };

  useEffect(() => {
    dispatch(getBusinessInfo('all'));
  }, []);

  useEffect(() => {
    setStoreInfo({
      ...storeInfo,

      businessName: businessInfo.businessName,
      businessDescription: businessInfo.businessDescription,

      phone: businessInfo.phone,
      notifPhone: businessInfo.notifPhone,
      neighborhood: businessInfo.neighborhood,
      // FIXME: Should not be an array
      businessCategory: businessInfo.businessCategory?.[0],

      hours: Array.isArray(businessInfo.hours) ? businessInfo.hours : [],

      allowDineIn: businessInfo.allowDineIn,
      inHouseDelivery: businessInfo.inHouseDelivery,
      isFreeDelivery: businessInfo.isFreeDelivery,
      minOrderAmt: businessInfo.minOrderAmt,
      maxDeliveryRange: businessInfo.maxDeliveryRange,
      deliveryChrgBase: businessInfo.deliveryChrgBase,
      deliveryPerAddlMile: businessInfo.deliveryPerAddlMile,

      businessLogo: businessInfo.businessLogo,
      businessPhotos: businessInfo?.businessPhotos ? businessInfo.businessPhotos : [],

      liveMessage: businessInfo.liveMessage,
      address: businessInfo.address,

      coordinates: businessInfo.coordinates,
    });
  }, [businessInfo]);

  useEffect(() => {
    handleStatus(status.updateBusinessInfo, () => dispatch(clearState(status.updateBusinessInfo)), {
      isSuccess: { callback: () => dispatch(getBusinessInfo('all')) },
    });
  }, [status.updateBusinessInfo]);

  // Business Logo
  const ReactS3Client = new S3(config);
  const handleImageDrop = (acceptedFiles) => {
    if (!['image/jpeg', 'image/png'].includes(acceptedFiles[0]?.type)) {
      toast.warning('Only .png and .jpg files are accepted');
      return;
    }

    const uploadImage = ReactS3Client.uploadFile(acceptedFiles[0]).then((image) => {
      updateStoreInfo('businessLogo', image.location);

      dispatch(
        updateBusinessInfo({
          data: {
            businessLogo: image.location,
          },
          fieldset: 'media',
        }),
      );
    });

    handleToast(uploadImage, {
      isSuccess: { message: 'Image Uploaded!' },
      isError: {
        message: 'Image could not be uploaded, please try again.',
      },
      isLoading: { message: `Uploading...` },
    });
  };

  const acceptableFormats = ['image/jpeg', 'image/png'];

  // Fields
  const handleLiveMessage = () => {
    if (storeInfo.liveMessage === '') {
      toast.error('Live messages cannot be blank');
      return;
    }
    dispatch(
      updateBusinessInfo({
        data: {
          liveMessage: storeInfo.liveMessage,
          displayLiveMessage: !businessInfo.displayLiveMessage,
        },
        fieldset: 'live-message',
      }),
    );
  };
  const setLiveMessage = () => {
    dispatch(
      updateBusinessInfo({
        data: {
          liveMessage: storeInfo.liveMessage,
          displayLiveMessage: false,
        },
        fieldset: 'live-message',
      }),
    );
  };
  const handleBusinessInfo = () => {
    const { businessName, businessCategory, neighborhood, phone, notifPhone, businessDescription, hours } =
      storeInfo;
    dispatch(
      updateBusinessInfo({
        data: {
          businessName,
          businessCategory,
          neighborhood,
          phones: [phone],
          notifPhone,
          businessDescription,
        },
        fieldset: 'business',
      }),
    );
  };

  const handleDelivery = () => {
    dispatch(
      updateBusinessInfo({
        data: {
          allowDineIn: storeInfo.allowDineIn,
          inHouseDelivery: storeInfo.inHouseDelivery,
          isFreeDelivery: storeInfo.isFreeDelivery,
          minOrderAmt: storeInfo.minOrderAmt,
          maxDeliveryRange: storeInfo.maxDeliveryRange,
          deliveryChrgBase: storeInfo.deliveryChrgBase,
          deliveryPerAddlMile: storeInfo.deliveryPerAddlMile,
        },
        fieldset: 'delivery',
      }),
    );
  };

  const handleBusinessPhotos = (photos) => {
    dispatch(
      updateBusinessInfo({
        data: {
          businessPhotos: photos,
        },
        fieldset: 'media',
      }),
    );
  };

  const handleHours = (images) => {
    dispatch(
      updateBusinessInfo({
        data: {
          hours: JSON.stringify(storeInfo.hours),
        },
        fieldset: 'business',
      }),
    );
  };

  return (
    <Page>
      {permissions.read.includes('store_info') ? (
        <>
          <div className={css['intro']}>
            {storeInfo.coordinates && (
              <GoogleMapReact
                options={createMapOptions}
                bootstrapURLKeys={{
                  key: 'AIzaSyBNeBOF4IceCyACowwiMUKi6ZUy_OeyqZU', // FIXME
                }}
                center={{
                  lat: storeInfo.coordinates[1],
                  lng: storeInfo.coordinates[0],
                }}
                defaultZoom={17}
                yesIWantToUseGoogleMapApiInternals
                // onClick={setMarker}
              >
                <MapMarker lat={storeInfo.coordinates[1]} lng={storeInfo.coordinates[0]} />
              </GoogleMapReact>
            )}

            <div className={css['store-logo']}>
              <img src={storeInfo.businessLogo} width="160px" height="160px" />
              {checkPermissions(permissions, { update: ['store_info'] }).hasPermission && (
                <Dropzone
                  onDrop={(acceptedFiles) => handleImageDrop(acceptedFiles)}
                  accept={['image/jpeg', 'image/png']}
                  onDropRejected={() =>
                    toast.error("This file can't be uploaded. Please try again with another image.")
                  }
                >
                  {({ getRootProps, getInputProps }) => (
                    <div {...getRootProps()} className={css['upload']}>
                      <input {...getInputProps()} />
                      <span>Edit Image</span>
                    </div>
                  )}
                </Dropzone>
              )}
            </div>
          </div>

          <div className={css['st-details']}>
            <div className={css['st-info']}>
              <h1>{storeInfo.businessName}</h1>
              <p className={css['st-location']}>
                <i className="fad fa-map-marker-alt" />
                {` ${storeInfo.address}`}
              </p>
            </div>
          </div>

          <ItemImages
            images={storeInfo.businessPhotos}
            setImages={(image) => updateStoreInfo('businessPhotos', image)}
            updateFunction={handleBusinessPhotos}
            allowUpload={checkPermissions(permissions, { update: ['store_info'] }).hasPermission}
          />

          <div className={css['live-message']} id="live">
            <header className={css['header']}>
              <h3>Live Message</h3>
            </header>
            <div>
              <input
                value={storeInfo.liveMessage}
                readOnly={
                  businessInfo.displayLiveMessage ||
                  !checkPermissions(permissions, { update: ['store_info'] }).hasPermission
                }
                onChange={(e) => updateStoreInfo('liveMessage', e.target.value)}
              />
              {checkPermissions(permissions, { update: ['store_info'] }).hasPermission && (
                <>
                  <Button
                    label={businessInfo.displayLiveMessage ? 'Stop' : 'Start'}
                    state={storeInfo.liveMessage == '' ? 'disabled' : null}
                    color={storeInfo.liveMessage == '' ? 'gray' : 'blue'}
                    action={handleLiveMessage}
                  />
                  <Button
                    label={businessInfo.liveMessage ? 'Clear' : 'Set'}
                    iconLeft={businessInfo.liveMessage ? 'fad fa-trash-alt' : 'fad fa-pencil'}
                    state={storeInfo.liveMessage == '' ? 'disabled' : null}
                    color={
                      storeInfo.liveMessage == ''
                        ? 'gray'
                        : businessInfo.liveMessage
                        ? 'red'
                        : 'emerald'
                    }
                    action={
                      businessInfo.liveMessage
                        ? () =>
                            dispatch(
                              updateBusinessInfo({
                                data: {
                                  liveMessage: '',
                                  displayLiveMessage: false,
                                },
                                fieldset: 'live-message',
                              }),
                            )
                        : () => setLiveMessage()
                    }
                    variant="secondary"
                  />
                </>
              )}
            </div>
          </div>

          <div className={css['grid']}>
            <div className={css['col']}>
              <h3>Hours</h3>
              <HoursSelector
                hours={storeInfo.hours}
                updateDay={updateIsClosed}
                updateHour={updateTime}
                addSubDay={(i, d) => addSubDay(i, d)}
                removeSubDay={(i) => removeSubDay(i)}
                userCanUpdate={
                  checkPermissions(permissions, {
                    update: ['store_info'],
                  }).hasPermission
                }
              />
              {checkPermissions(permissions, { update: ['store_info'] }).hasPermission && (
                <div className={css.savebutton}>
                  <Button label="Save" color="emerald" action={handleHours} />
                </div>
              )}
            </div>

            <div className={css['col']}>
              <div className={css['details']}>
                <h3>Contact Info</h3>
                {/* <div className={css["half-input"]}> */}
                <InputWrap
                  label="Phone"
                  component={
                    <NumberFormat
                      allowEmptyFormatting
                      mask="_"
                      format="+1 (###) ###-####"
                      type="tel"
                      value={storeInfo.phone}
                      onChange={(e) => updateStoreInfo('phone', e.target.value)}
                      readOnly={
                        !checkPermissions(permissions, {
                          update: ['store_info'],
                        }).hasPermission
                      }
                    />
                  }
                />
                <InputWrap
                  label="Notification Phone (Optional)"
                  helpText="Enter a number if you want to separate Livecart notifications from customer calls."
                  component={
                    <NumberFormat
                      allowEmptyFormatting
                      mask="_"
                      format="+1 (###) ###-####"
                      type="tel"
                      value={storeInfo.notifPhone}
                      onChange={(e) => updateStoreInfo('notifPhone', e.target.value)}
                      readOnly={
                        !checkPermissions(permissions, {
                          update: ['store_info'],
                        }).hasPermission
                      }
                    />
                  }
                />
                <InputWrap
                  label="Neighborhood"
                  component={
                    <input
                      type="text"
                      value={storeInfo.neighborhood}
                      onChange={(e) => updateStoreInfo('neighborhood', e.target.value)}
                      readOnly={
                        !checkPermissions(permissions, {
                          update: ['store_info'],
                        }).hasPermission
                      }
                    />
                  }
                />
                {/* </div> */}
                <InputWrap
                  label="Category"
                  component={
                    <Select
                      options={categories}
                      className={css.select}
                      onChange={(option) => updateStoreInfo('businessCategory', option.value)}
                      value={{
                        label:
                          storeInfo?.businessCategory?.[0]?.toUpperCase() +
                          storeInfo?.businessCategory?.slice(1),
                        value: storeInfo?.businessCategory,
                      }}
                      isDisabled={
                        !checkPermissions(permissions, {
                          update: ['store_info'],
                        }).hasPermission
                      }
                      // isMulti={true}
                    />
                  }
                />
                <InputWrap
                  label="Store Description"
                  component={
                    <textarea
                      value={storeInfo.businessDescription}
                      onChange={(e) => updateStoreInfo('businessDescription', e.target.value)}
                      readOnly={
                        !checkPermissions(permissions, {
                          update: ['store_info'],
                        }).hasPermission
                      }
                    />
                  }
                />

                {checkPermissions(permissions, { update: ['store_info'] }).hasPermission && (
                  <Button label="Save" color="emerald" action={handleBusinessInfo} />
                )}
              </div>
            </div>
            <div className={css['col']}>
              <div className={css['delivery-options']}>
                <h3>Delivery Options</h3>

                <div>
                  <p>Dine-in</p>
                  <Switch
                    action={() => updateStoreInfo('allowDineIn', !storeInfo.allowDineIn)}
                    isActive={storeInfo?.allowDineIn}
                    disabled={
                      !checkPermissions(permissions, {
                        update: ['store_info'],
                      }).hasPermission
                    }
                  />
                </div>

                <div>
                  <p>In-House Delivery</p>
                  <Switch
                    action={() => updateStoreInfo('inHouseDelivery', !storeInfo.inHouseDelivery)}
                    isActive={storeInfo?.inHouseDelivery}
                    disabled={
                      !checkPermissions(permissions, {
                        update: ['store_info'],
                      }).hasPermission
                    }
                  />
                </div>

                {storeInfo?.inHouseDelivery && (
                  <>
                    <div>
                      <p>Free Delivery</p>
                      <div>
                        <Switch
                          action={() =>
                            updateStoreInfo('isFreeDelivery', !storeInfo.isFreeDelivery)
                          }
                          isActive={storeInfo?.isFreeDelivery}
                          disabled={
                            !checkPermissions(permissions, {
                              update: ['store_info'],
                            }).hasPermission
                          }
                        />
                      </div>
                    </div>

                    {!storeInfo?.isFreeDelivery && (
                      <>
                        <div>
                          <p>Base Charge ($)</p>
                          <input
                            type="number"
                            value={storeInfo?.deliveryChrgBase}
                            onChange={(e) => updateStoreInfo('deliveryChrgBase', e.target.value)}
                            disabled={
                              !checkPermissions(permissions, {
                                update: ['store_info'],
                              }).hasPermission
                            }
                          />
                        </div>
                        <div>
                          <p>Charge Per Additional Mile ($)</p>
                          <input
                            type="number"
                            value={storeInfo?.deliveryPerAddlMile}
                            onChange={(e) => updateStoreInfo('deliveryPerAddlMile', e.target.value)}
                            disabled={
                              !checkPermissions(permissions, {
                                update: ['store_info'],
                              }).hasPermission
                            }
                          />
                        </div>
                      </>
                    )}
                  </>
                )}

                <div>
                  <p>Minimum Order ($)</p>
                  <input
                    type="number"
                    value={storeInfo?.minOrderAmt}
                    onChange={(e) => updateStoreInfo('minOrderAmt', e.target.value)}
                    disabled={
                      !checkPermissions(permissions, {
                        update: ['store_info'],
                      }).hasPermission
                    }
                  />
                </div>

                <div>
                  <p>Max Delivery Distance (Miles)</p>
                  <input
                    type="number"
                    value={storeInfo?.maxDeliveryRange}
                    onChange={(e) => updateStoreInfo('maxDeliveryRange', e.target.value)}
                    disabled={
                      !checkPermissions(permissions, {
                        update: ['store_info'],
                      }).hasPermission
                    }
                  />
                </div>

                {/* FIXME: */}
                {checkPermissions(permissions, { update: ['store_info'] }).hasPermission && (
                  <Button label="Save" color="emerald" action={handleDelivery} />
                )}
              </div>
            </div>
          </div>
        </>
      ) : (
        <EmptyPage
          title="You don’t have permission to view anything on this page"
          text="Ask your employer for access"
          iconName="fad fa-lock"
        />
      )}
    </Page>
  );
}
